// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","597":"projects"}[chunkId] + "." + {"594":"5108ca1b","597":"7a9e4312"}[chunkId] + ".css";
};